var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: _vm.observeVisibilityOptions,
          expression: "observeVisibilityOptions",
        },
        {
          name: "touch",
          rawName: "v-touch:swipe.left",
          value: _vm.debouncedNext,
          expression: "debouncedNext",
          arg: "swipe",
          modifiers: { left: true },
        },
        {
          name: "touch",
          rawName: "v-touch:swipe.right",
          value: _vm.debouncedPrevious,
          expression: "debouncedPrevious",
          arg: "swipe",
          modifiers: { right: true },
        },
        {
          name: "touch-options",
          rawName: "v-touch-options",
          value: { swipeTolerance: 30 },
          expression: "{swipeTolerance: 30}",
        },
      ],
      staticClass: "home-front-pages",
      style: _vm.backgroundStyle,
    },
    [
      (_vm.currentHero &&
        _vm.currentHero.Name === "intro" &&
        _vm.isIntersectionVisible) ||
      _vm.heros.length <= 1
        ? _c("home-hero-page", {
            ref: "heroPage",
            staticClass: "taide-art",
            class:
              (_vm.showInfobox ? "infobox-visible" : "infobox-hidden") +
              (_vm.coverImageIndex < 1 ? " initial" : ""),
            attrs: { spotlight: _vm.introHero, "next-item": _vm.nextItem },
            scopedSlots: _vm._u(
              [
                {
                  key: "infobox",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "logo" },
                        [
                          _c("image-box", {
                            attrs: {
                              src: require("assets/images/taide-art-white.svg"),
                              "image-alt-text": "taide.art",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "not-available",
                                  fn: function () {
                                    return [
                                      _c("div", { staticClass: "is-hidden" }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2309297513
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.loginPhase === _vm.phaseBusy
                        ? _c(
                            "div",
                            { staticClass: "logging-in" },
                            [_c("loading-spinner")],
                            1
                          )
                        : _c("div", { staticClass: "call-to-action" }, [
                            _c("h3", {
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("home.callToAction")),
                              },
                            }),
                          ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2418546234
            ),
          })
        : _vm.isIntersectionVisible
        ? _c("home-hero-page", {
            ref: "heroPage",
            class: _vm.showInfobox ? "infobox-visible" : "infobox-hidden",
            attrs: {
              spotlight: _vm.currentItem,
              "resource-type": _vm.currentResourceType,
              "next-item": _vm.nextItem,
            },
            scopedSlots: _vm._u([
              {
                key: "infobox",
                fn: function () {
                  return [
                    _vm.currentResourceType === "Artwork"
                      ? _c("artwork-card", {
                          attrs: {
                            item: _vm.currentItem,
                            "link-to-artwork": true,
                            social: false,
                            media: false,
                          },
                        })
                      : _vm.currentResourceType === "FeatureArticle"
                      ? _c("feature-article-card", {
                          class: _vm.coverImageIndex % 2 === 0 ? "odd" : "even",
                          attrs: {
                            item: _vm.currentItem,
                            hero: true,
                            header: false,
                          },
                        })
                      : _vm.currentResourceType === "Collection"
                      ? _c(
                          "collection-card",
                          { attrs: { item: _vm.currentItem, social: false } },
                          [
                            _vm.currentItem.TagLine
                              ? _c("div", { staticClass: "tagline" }, [
                                  _vm._v(_vm._s(_vm.currentItem.TagLine)),
                                ])
                              : _vm._e(),
                            _vm.currentItem.IngressText
                              ? _c("div", {
                                  staticClass: "ingress-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentItem.IngressText
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm.currentItem.BodyHtml
                              ? _c("div", {
                                  staticClass: "body-html",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.currentItem.BodyHtml),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _vm.currentResourceType === "Event"
                      ? _c(
                          "event-card",
                          {
                            attrs: {
                              item: _vm.currentItem,
                              resolution: { x: "100vw", y: "100vh" },
                              social: false,
                            },
                          },
                          [
                            _vm.currentItem.TagLine
                              ? _c("div", { staticClass: "tagline" }, [
                                  _vm._v(_vm._s(_vm.currentItem.TagLine)),
                                ])
                              : _vm._e(),
                            _vm.currentItem.IngressText
                              ? _c("div", {
                                  staticClass: "ingress-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentItem.IngressText
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _vm.currentResourceType === "Actor"
                      ? _c("actor-highlights", {
                          ref: "actorHighlights",
                          attrs: {
                            items: [_vm.currentItem],
                            "slick-options": _vm.unSlickOptions,
                            "show-body": false,
                            "show-artworks": false,
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }